const PRODUCT_ID_BY_SERVICE_ID = {
  "portfolio-review": "portfolio_review",
  "creator-channel-review": "creator_channel_review",
  "verified-portfolio-review": "verified_portfolio_review",
  "featured-spotlight": "featured_spotlight_week",
};

export function toBackendPlanId(planId) {
  return String(planId || "").replaceAll("-", "_");
}

export function toBackendProductId(productId) {
  return PRODUCT_ID_BY_SERVICE_ID[productId] || toBackendPlanId(productId);
}

export async function createPricingCheckoutSession({
  endpoint,
  path,
  payload,
}) {
  if (!endpoint) {
    throw new Error("Checkout endpoint is not configured.");
  }

  const response = await fetch(`${endpoint}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Unable to start checkout.");
  }
  if (!data.url) {
    throw new Error("Checkout session did not return a Stripe URL.");
  }

  return data;
}
